import './style.scss';
import { useSelector } from 'react-redux';
import { GlobalState } from '../../../../../../store/types';
import logo from '../../../../../../assets/LogoIcon.svg';

type Props = {
  fullScreenMode: boolean;
};

function Footer({ fullScreenMode }: Props) {
  const enableFooterLogo = useSelector((state: GlobalState) => state.responses.enableFooterLogo);
  const enableHyperlink = useSelector((state: GlobalState) => state.responses.enableHyperlink);

  return (
    <>
      {enableFooterLogo && (
        <div className={fullScreenMode ? 'company-footer-fs' : 'company-footer'}>
          <img src={logo} style={{ height: '16px', width: '16px', marginRight: '4px' }} alt="" />
          by&nbsp;
          {enableHyperlink ? (
            <a
              style={{ textDecoration: 'none', color: 'grey', outline: 'none' }}
              target="blank"
              href={'https://www.imbee.io'}
            >
              imBee
            </a>
          ) : (
            <span style={{ color: 'grey' }}>imBee</span>
          )}
        </div>
      )}
    </>
  );
}

export default Footer;
